// extracted by mini-css-extract-plugin
export var aboveInput = "_n8-0";
export var actionButton = "_n8-5";
export var actionButtonContainer = "_n8-1";
export var actionIcon = "_n8-6";
export var aiInfoContainer = "_n8-2";
export var attachmentWrapper = "_n8-7";
export var bold = "_n8-3";
export var checkIcon = "_n8-8";
export var clickingRecipientBar = "_n8-11";
export var commentThreadSwitch = "_n8-a";
export var draftImage = "_n8-b";
export var draftImageContainer = "_n8-c";
export var draftImages = "_n8-e";
export var editButton = "_n8-g";
export var editor = "_n8-f";
export var editorContainer = "_n8-y";
export var editorErrorTooltipWrapper = "_n8-9";
export var headerDivider = "_n8-h";
export var icon = "_n8-i";
export var info = "_n8-j";
export var internal = "_n8-n";
export var internalDivider = "_n8-k";
export var internalMessage = "_n8-l";
export var messageInputCard = "_n8-m";
export var messageInputForm = "_n8-o";
export var messageInputFormInternal = "_n8-p";
export var options = "_n8-q";
export var publicMessageCustomer = "_n8-s";
export var publicMessageMerchant = "_n8-r";
export var removeImageButton = "_n8-d";
export var replyButtons = "_n8-t";
export var showSignatureButton = "_n8-u";
export var spinner = "_n8-v";
export var verticalButtonDivider = "_n8-4";
export var visibilitySelector = "_n8-w";
export var warning = "_n8-x";
export var wrappingText = "_n8-z";
export var writingInternalNoteTopBorder = "_n8-10";